import { Component, Input, Output, EventEmitter } from "@angular/core";
import { EcertBaseBlockComponent } from "../ecertnl-base-block/ecertnl-base-block.component";

@Component({
  selector: "ecert-select",
  templateUrl: "./ecertnl-select.component.html",
  styleUrls: ["./ecertnl-select.component.css"],
  standalone: false,
})
export class EcertSelectComponent extends EcertBaseBlockComponent {
  @Input() id: any;
  @Input() set opties(opties: any) {
    this._opties = opties;

    //Als verplicht en er is maar één optie, dan wordt de select ingevuld met deze optie.
    if (
      opties != undefined &&
      opties.length == 1 &&
      this.ref_object[this.property] == null
    ) {
      this.ref_object[this.property] = opties[0][this.optionValueProperty];
    }
  }

  @Input() optionLabelProperty: any = "label";
  @Input() optionValueProperty: any = "value";

  _opties: any;

  onBlur() {}

  change(event) {
    this.onChange.emit(event);
  }

  constructor() {
    super();
  }

  hasMargin() {
    if (this.action_identifier == "CODE_LIJSTEN.CODELIJST") {
      return false;
    } else {
      return true;
    }
  }
}
